import { SourceHolder, SourceProviderFactory } from '@/components/canvas/CanvasElementSourceProviders/SourceProviderFactory'
import { useCamerasStore } from '@/store/cameras'
import router from '@/router'
import { useLogsStore } from '@/store/logs'
import { humanReadableTimestamp } from '@/composables/datetime'
import { Camera } from '@/types/Cameras'

type StillFrameSourceData = object

export class StillFrameSourceHolder extends SourceHolder<StillFrameSourceData> {
  readonly supportedHeights: number[] = [20, 50, 150, 270, 540, 800, 1080]

  async loadSourceData(): Promise<StillFrameSourceData | null> {
    return {}
  }
  async loadSource(height: number, signal: AbortSignal, isInView: boolean): Promise<string | null> {
    if (signal.aborted) return null
    const source: string | null = await useCamerasStore().loadFrameForTimestamp(
      this.cameraId,
      this.timestamp,
      height,
      false,
      1000 * 60 * 10,
      //@ts-expect-error camera store isn't typed yet
      signal,
      isInView
    )
    if (signal.aborted) return null
    return source
  }

  ondblclick(): void {
    router
      .push({
        name: 'CameraView',
        params: {
          globalUniqueIdentifier: router.currentRoute.value.params.globalUniqueIdentifier,
          cameraId: this.cameraId,
        },
      })
      .catch(e => {
        useLogsStore().addLogEntry({
          level: 'ERROR',
          message: `Error navigating to camera view for camera ${this.cameraId}`,
          error: e,
          tag: 'canvas',
        })
      })
  }
  onContextMenu() {}

  getTooltipText(): string {
    if (!this.canShowTooltip()) return ''
    return `${this.camera.name} - ${humanReadableTimestamp(this.timestamp, false)}`
  }

  canShowTooltip(): boolean {
    return !!this.camera
  }
}

export class StillFrameSourceProviderFactory extends SourceProviderFactory<StillFrameSourceHolder> {
  readonly providerType: string = 'stillFrame'

  createSourceHolder(cameraId: string, timestamp: number, camera: Camera): StillFrameSourceHolder {
    return new StillFrameSourceHolder(cameraId, timestamp, camera)
  }
}
